export default {
  init() {
    if (document.querySelector('.upload__field')) {
      let fi = document.querySelector('.upload__field')
      let dom = document.querySelector('.upload__file')
      fi.onchange = function() {
        if (fi.files.length > 0) {
          for (var i = 0; i <= fi.files.length - 1; i++) {
            dom.innerHTML = '<span>' + fi.files.item(i).name + '</span>'
          }
        }
      }
    }
  },
}

// import $ from 'jquery'

// class Fileinfo {
//   constructor(item) {
//     this.item = $(item)
//     this.trigger = $('.upload input', item)
//     this.content = $('.upload__file', item)

//     this.init()
//   }

//   init() {
//     this.trigger('change', () => {
//       var filename = $(this.trigger).val().split('\\').pop();
//       console.log(filename)
//       if (this.trigger.files.length > 0) {
//         for (var i = 0; i <= this.trigger.files.length - 1; i++) {
//           content.innerHTML = '<span>' + this.trigger.files.item(i).name + '</span>'
//         }
//       }
//     })
//   }
// }

// export default Fileinfo
